import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-luxury-white mt-20">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex flex-col mb-4">
              <span className="text-2xl font-serif font-bold text-luxury-accent tracking-[0.15em]">
                NIHIRA
              </span>
              <span className="text-[0.6rem] font-sans font-light tracking-[0.3em] uppercase opacity-90">
                REALTORS LLP
              </span>
            </div>
            <p className="text-luxury-light leading-relaxed text-sm">
              In the last many years, we have completed the 19.02 lakhs sqft land construction. Creating exceptional living spaces with quality craftsmanship and attention to detail.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4 text-luxury-white">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Projects', 'Gallery', 'Contact Us'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase().replace(' ', '-')}`}
                    className="text-luxury-light hover:text-luxury-accent hover:pl-1 transition-all duration-300 text-sm"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Projects */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4 text-luxury-white">
              Our Projects
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/projects/crown-villas"
                  className="text-luxury-light hover:text-luxury-accent hover:pl-1 transition-all duration-300 text-sm"
                >
                  The Crown Villas
                </Link>
              </li>
              <li>
                <Link
                  to="/projects/royal-oak"
                  className="text-luxury-light hover:text-luxury-accent hover:pl-1 transition-all duration-300 text-sm"
                >
                  Royal Oak Estates
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4 text-luxury-white">
              Contact Info
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="text-luxury-light">
                6-50/6/101, Chandanagar
              </li>
              <li>
                <a
                  href="mailto:preetham.miriyala@gmail.com"
                  className="text-luxury-light hover:text-luxury-accent transition-colors duration-300"
                >
                  preetham.miriyala@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+919584646464"
                  className="text-luxury-light hover:text-luxury-accent transition-colors duration-300"
                >
                  +91 9584646464
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-luxury-white/10 text-center">
          <p className="text-luxury-secondary text-sm">
            &copy; {new Date().getFullYear()} NIHIRA REALTORS LLP. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
